import { resizeHandleTypes } from 'InpageEditorUI/lib/layoutSection/constants';
export function calculateColumnResizeHandlesFromHoverPositions(hoverPositions) {
  const resizeHandles = [];
  if (hoverPositions.length === 0) {
    return resizeHandles;
  }
  for (const hoverPosition of hoverPositions) {
    if (hoverPosition.isColumn && hoverPosition.nextColumnId) {
      resizeHandles.push({
        id: hoverPosition.id,
        type: resizeHandleTypes.RESIZE_HANDLE_RIGHT
      });
    }
    if (hoverPosition.previousColumnId) {
      resizeHandles.push({
        id: hoverPosition.id,
        type: resizeHandleTypes.RESIZE_HANDLE_LEFT
      });
    }
    if (resizeHandles.length) {
      break;
    }
  }
  return resizeHandles;
}